window.Minus40Request = class Minus40Request
{

    /** @type {Minus40Request} */
    static instance = null;

    static getInstance() {
        if(this.instance !== null) {
            return this.instance;
        }
        this.instance = new Minus40Request();
        return this.instance;
    }

    apiHome = "";

    constructor() {
        this.core = Minus40Core.getInstance();
        this.apiHome = this.core.pageVars.apiHome ?? "";
    }


    /**
     *
     * @param endpoint {string}
     * @param httpMethod {string|null=}
     * @param params {{}|BodyInit|null=}
     * @param authorization {string|null=}
     * @param contentTypeID {string|null=}
     * @returns {{}}
     * @throws {Minus40ApiError}
     */
    async fetchData(endpoint, httpMethod, params, authorization, contentTypeID) {
        contentTypeID = contentTypeID ? contentTypeID : "json"
        httpMethod = (httpMethod ?? "GET").toUpperCase();

        endpoint = this.core.trimSlashes(endpoint);
        const isPrimaryAPI = !endpoint.startsWith("http://") && !endpoint.startsWith("https://");
        if(isPrimaryAPI){
            endpoint = this.apiHome + "/" + endpoint;
        }
        let bodyData = null;
        if (httpMethod === "GET") {
            endpoint = this.addQueryParams(endpoint, params);
        } else {
            if (params) {
                if(contentTypeID === "json"){
                    bodyData = JSON.stringify(params);
                } else if(contentTypeID === "formdata"){
                    if(!(params instanceof FormData)) {
                        bodyData = new FormData();
                        for(let key in params) {

                            bodyData.append( key, params[key] );
                        }
                    }
                } else {
                    bodyData = params;
                }
            }
        }

        const headers = {
            'Connection': 'keep-alive'
        }
        if (contentTypeID === "json") {
            headers['Content-Type'] = 'application/json; charset=UTF-8';
        }

        if (authorization) {
            headers.Authorization = authorization;
        }


        let fetchResponse = null;
        const parsedResponse = await fetch(endpoint, {
            method: httpMethod,
            headers: headers,
            body: bodyData,
        })
            .then((response) => {
                const apiError = this.determineApiError(response);
                fetchResponse = response;
                return response.json().then(json => {
                    if (!this.core.isObject(json) && !this.core.isArray(json)) {
                        const status = response.hasOwnProperty("status") ? response.status : 200;
                        if(response.status && (response.status < 200 || response.status >= 300)) {

                            const apiError=  new Minus40ApiError()
                            apiError.status = response.status;
                            apiError.message = response.statusText ? response.statusText : (json ? json : "Unknown Error");
                            apiError.code = apiError.status.toString();
                            throw apiError;
                        }
                    }
                    return json;
                });
            })
            .then((response) => {
                if (response) {
                    if (!this.core.isObject(response)) {
                        if (this.core.isArray(response) && response.length) {
                            response = {values: response};
                        } else {
                            response = {
                                data: response
                            };
                        }
                    }
                } else {
                    response = {};
                }
                let hasError = false;

                let data = this.core.isObject(response.data) ? response.data : {};
                if(!response.hasOwnProperty("success")){
                    response = {
                        success: true,
                        data: response
                    }
                } else if (data.data && this.core.isObject(data.data)) {
                    hasError = !response.success;
                    response = data;
                }

                response.fetch_response = response.fetch_response ?? {
                    status: fetchResponse?.status ? fetchResponse?.status : null,
                    statusText: fetchResponse?.statusText ? fetchResponse?.statusText : null
                };

                const apiError = this.determineApiError(response, hasError);
                if(apiError){
                    throw apiError;
                }

                return response;
            })
            .catch((error) => {

                if(error instanceof Minus40ApiError) {
                    return error;
                }
                let code = "";
                let message = "";
                let info = {};
                if(this.core.isString(error)) {
                    code = error;
                    message = error;
                } else
                {
                    info = error;
                    if(this.core.isObject(error)) {
                        code = error.code ?? (error.message ?? "");
                        message = error.message ?? (error.code ?? "");
                    }
                }
                const apiError=  new Minus40ApiError()
                apiError.status = 404;
                apiError.code = code;
                apiError.message = message;
                apiError.info = info;
                throw apiError;
            });
        if(parsedResponse instanceof Minus40ApiError){
            throw parsedResponse;
        }
        return parsedResponse;
    }

    /**
     *
     * @param value {any}
     * @returns {string|undefined}
     */
    prepareQueryValue(value)
    {
        let useValue = undefined;
        if(value === undefined){
            return useValue;
        }
        if(this.core.isString(value)){
            return value;
        } else if(this.core.isNumber(value)){
            return value.toString();
        } else if(this.core.isBool(value)){
            return value ? "1" : "";
        } else if (value) {
            const jsonValue = JSON.stringify(value);
            if(jsonValue){
                return jsonValue;
            }
        }
        return useValue;
    }

    /**
     *
     * @param endpoint {string}
     * @param params {{}|null}
     * @returns {string}
     */
    addQueryParams(endpoint, params)
    {
        if(!params){
            return endpoint;
        }
        let useAnd = endpoint.includes("?");
        for(let key in params){
            const value = params[key];
            const useValue = this.prepareQueryValue(value);
            if(useValue === undefined){
                continue;
            }
            endpoint += !useAnd ? "?" : "&";
            endpoint += key + "=" + encodeURIComponent(useValue);
            useAnd = true;
        }
        return endpoint;
    }

    /**
     *
     * @param response {{error_data:any=, data:{}=, errors:{}=, code:string=, message:string=, fetch_response:{}=, title:string=}|Response}
     * @param required {boolean=}
     * @param defaultErrorCode {number=}
     * @returns {Minus40ApiError|null}
     */
    determineApiError(response, required, defaultErrorCode) {

        required = required ?? false;
        defaultErrorCode = defaultErrorCode  ?? 0;

        if(!this.core.isObject(response)){
            if(required){
                response = {};
            } else {
                return null;
            }
        }

        let status = null;
        let code = "";
        let message = "";
        let dataErrors = {};
        let info = {};
        let data = this.core.isObject(response.data) ? response.data : (this.core.isArray(response.data) && this.core.isObject(response.data[0]) ? response.data[0] : {});
        if(this.core.isObject(data.data) && !isNaN(data.data.status)){
            response = data;
            data = data.data;
        } else if(this.core.isArray(data.data) && this.core.isObject(data.data[0]) && !isNaN(data.data[0].status)){
            response = data;
            data = data.data[0];
        }

        let responseErrorData = this.core.isObject(response.error_data, true) ? response.error_data : null;
        let responseErrors = this.core.isObject(response.errors, true) ? response.errors : null;
        if(!responseErrorData){
            if(data){
                responseErrorData = this.core.isObject(data.error_data, true) ? data.error_data : null;
                responseErrors = this.core.isObject(data.errors, true) ? data.errors : null;
            }
        }

        if(responseErrorData && responseErrors){
            code = this.core.firstKey(responseErrorData) ?? "";
            if(responseErrors[code]){
                const data = this.core.isObject(responseErrorData[code]) ? responseErrorData[code] : {};
                status = data.status && !isNaN(data.status) ? parseInt(data.status) : null;
                message = this.core.isArray(responseErrors[code]) && responseErrors[code].length ? responseErrors[code][0] : "";
                dataErrors = this.core.isObject(data.errors) ? data.errors : {};
                info = this.core.isObject(data.info) ? data.info : {};
            }
        } else if(Object.keys(data).length) {

            status = data.status && !isNaN(data.status) ? parseInt(data.status) : null;
            code = this.core.isString(data.code) ? data.code : (this.core.isString(response.code) ? response.code : "");
            message = this.core.isString(data.message) ? data.message : (this.core.isString(response.message) ? response.message : "");
            dataErrors = this.core.isObject(data.errors) ? data.errors : (this.core.isObject(response.errors) ? response.errors : {});
            info = this.core.isObject(data.info) ? data.info : (this.core.isObject(response.info) ? response.info : {});
        }

        if(response.fetch_response){
            if(!status){
                status = response.fetch_response.status && !isNaN(response.fetch_response.status) ? parseInt(response.fetch_response.status) : null;
            }
            if(!message){
                message = this.core.isString(response.fetch_response.statusText) && response.fetch_response.statusText ?
                    response.fetch_response.statusText : (this.core.isString(response.title) ? response.title : "");
            }
        }

        if(!status && code === "qm_fatal"){
            status = 500;
        }

        if(status === null){
            if(!required){
                return null;
            }
            status = defaultErrorCode;
        }

        if(status >= 200 && status < 300) {
            if(!required){
                return null;
            }
            status = defaultErrorCode;
        }

        const apiError = new Minus40ApiError();
        apiError.status = status;
        apiError.code = code;
        const errorCodeParts = apiError.code.split(" ");
        if(errorCodeParts.length){
            apiError.code = errorCodeParts[errorCodeParts.length - 1];
        }
        apiError.message = message ? message : (apiError.code ? apiError.code : "Unknown Error [3]");
        apiError.lineErrors = this.determineLineErrors(dataErrors);
        apiError.info = info;
        return apiError;
    }

    /**
     *
     * @param dataErrors {{}}
     * @returns {{}}
     */
    determineLineErrors (dataErrors)
    {
        const lineErrors = {};

        /**
         *
         * @param formLineErrors {any}
         * @returns {string[]}
         */
        const determineLineMessages = (formLineErrors) => {
            if(!this.core.isArray(formLineErrors)){
                formLineErrors = [formLineErrors];
            }
            const lineMessages = [];
            for(let i = 0; i < formLineErrors.length; i ++){
                let errorLine = formLineErrors[i];
                let lineMessage = null;
                if(this.core.isObject(errorLine)){
                    if(this.core.isString(errorLine.message)){
                        lineMessage = errorLine.message;
                    } else if(this.core.isString(errorLine.code)){
                        lineMessage = errorLine.code;
                    }
                } else if(this.core.isString(errorLine)){
                    lineMessage = errorLine;
                }
                if(lineMessage){
                    lineMessages.push(this.core.stripHTML(lineMessage));
                }
            }
            return lineMessages;
        }

        for(let lineID in dataErrors)
        {
            if(!['line', 'object', 'array'].includes(lineID))
            {
                const lineMessages = determineLineMessages(dataErrors[lineID]);
                if(lineMessages.length)
                {
                    const key = this.preparedPointer(lineID);
                    const lineError = {
                        fieldID: key.fieldID,
                        itemID: key.itemID,
                        key: key,
                        errors: lineMessages
                    }
                    lineErrors[lineError.itemID] = lineError;
                }
            }
        }

        /**
         *
         * @param fromObject {{}}
         * @returns {[]}
         */
        const determineNestedLineErrors = (fromObject) => {
            const nestedLineErrors = [];
            if(fromObject.line){
                for(let lineID in fromObject.line){
                    const lineMessages = determineLineMessages(fromObject.line[lineID]);
                    if(lineMessages.length)
                    {
                        const key = this.preparedPointer(lineID);
                        const lineError = {
                            fieldID: key.fieldID,
                            itemID: key.itemID,
                            key: key,
                            errors: lineMessages
                        }
                        nestedLineErrors.push(lineError);
                    }
                }
            }
            if(this.core.isObject(fromObject.object)){
                for(let objectID in fromObject.object){
                    const childObject = fromObject.object[objectID];
                    if(this.core.isObject(childObject)){
                        const childLineErrors = determineNestedLineErrors(childObject);
                        for(const childLineError of childLineErrors)
                        {
                            const isNoLine = childLineError.fieldID === "NO_LINE" && !childLineError.key.childPointer;
                            const key = this.preparedPointer({
                                fieldID: objectID,
                                childPointer: !isNoLine ? childLineError.key : null
                            })
                            childLineError.key = key
                            childLineError.itemID = key.itemID;
                            if(isNoLine){
                                childLineError.fieldID = key.fieldID;
                            }
                            nestedLineErrors.push(childLineError);
                        }
                    }
                }
            }
            if(this.core.isObject(fromObject.array)){
                for(let arrayID in fromObject.array){
                    const childArray = fromObject.array[arrayID];
                    if(this.core.isObject(childArray) || this.core.isArray(childArray)){
                        for(let arrayIndex in childArray){
                            const arrayObject = childArray[arrayIndex];
                            if(this.core.isNumeric(arrayIndex) && this.core.isObject(arrayObject)){
                                const childLineErrors = determineNestedLineErrors(arrayObject);
                                for(const childLineError of childLineErrors)
                                {
                                    const isNoLine = childLineError.fieldID === "NO_LINE" && !childLineError.key.childPointer;
                                    const key = this.preparedPointer({
                                        fieldID: arrayID,
                                        index: parseInt(arrayIndex),
                                        childPointer: !isNoLine ? childLineError.key : null
                                    })
                                    childLineError.key = key
                                    childLineError.itemID = key.itemID;
                                    if(isNoLine){
                                        childLineError.fieldID = key.fieldID;
                                    }
                                    nestedLineErrors.push(childLineError);
                                }
                            }
                        }
                    }
                }
            }
            return nestedLineErrors;
        }

        const nestedLineErrors = determineNestedLineErrors(dataErrors);
        for(const nestedLineError of nestedLineErrors)
        {
            lineErrors[nestedLineError.itemID] = nestedLineError;
        }

        return lineErrors;
    }

    /**
     *
     * @param pointer {{fieldID:string, itemID:string=, collectionType:string=, index:number=, childPointer:{}=}|string}
     * @returns {{fieldID:string, itemID:string, collectionType:string, index:number|null, childPointer:{}|null}}
     */
    preparedPointer (pointer)
    {
        pointer = typeof pointer === 'string' ? {fieldID: pointer} : pointer;
        if(pointer.itemID){
            return pointer;
        }

        pointer.index = pointer.index ?? null;
        pointer.childPointer = pointer.childPointer ?? null;

        let itemID = "id: " + pointer.fieldID;
        if(pointer.index !== null)
        {
            pointer.collectionType = "group_array";
            itemID += ", index: "+pointer.index;
        } else if(pointer.childPointer){
            pointer.collectionType = pointer.collectionType === "id_array" ? "id_array" : "group_object";
        } else {
            pointer.collectionType = "single";
        }
        if(pointer.childPointer){
            /** @type {any} */
            const childPointer = pointer.childPointer;
            pointer.childPointer = this.preparedPointer(childPointer);
            itemID += " >> " + pointer.childPointer.itemID;
        }
        pointer.itemID = itemID;
        return pointer;
    }
}



